import { Component, OnInit } from '@angular/core';

const THEME_KEY = 'bt-theme-preference'; // matches ui2's key/convention (per-origin storage)

/** Toggles body.theme-light / body.theme-dark, matching ui2's class-switching
 * convention exactly so the @use'd design tokens apply without local re-styling.
 * Persists the choice; index.html applies it pre-boot to avoid a flash. */
@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  template: `
    <button type="button" class="theme-toggle" data-testid="theme-toggle-button" (click)="toggle()"
            [attr.aria-label]="isDark ? 'Switch to light theme' : 'Switch to dark theme'"
            [title]="isDark ? 'Switch to light theme' : 'Switch to dark theme'">
      @if (isDark) {
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="4"></circle>
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"></path>
        </svg>
      } @else {
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
        </svg>
      }
    </button>
  `,
  styles: [`
    .theme-toggle {
      width: 36px; height: 36px; display: inline-flex; align-items: center; justify-content: center;
      border: 1px solid var(--bt-border-default); border-radius: 8px;
      background: var(--bt-bg-surface); color: var(--bt-text-secondary); cursor: pointer;
      transition: background-color .13s ease, color .13s ease, border-color .13s ease;
    }
    .theme-toggle:hover { background: var(--bt-bg-surface-2); color: var(--bt-text-primary); border-color: var(--bt-border-focus); }
  `],
})
export class ThemeToggleComponent implements OnInit {
  isDark = false;

  ngOnInit(): void {
    this.isDark = (localStorage.getItem(THEME_KEY) || 'light') === 'dark';
    this.apply();
  }

  toggle(): void {
    this.isDark = !this.isDark;
    localStorage.setItem(THEME_KEY, this.isDark ? 'dark' : 'light');
    this.apply();
  }

  private apply(): void {
    document.body.classList.toggle('theme-dark', this.isDark);
    document.body.classList.toggle('theme-light', !this.isDark);
  }
}
